export const GET_ADMIN_USERS = "GET_ADMIN_USERS";
export const GET_ADMIN_USERS_SUCCESS = "GET_ADMIN_USERS_SUCCESS";
// export const UPDATE_ADMIN_PROFILE = "UPDATE_ADMIN_PROFILE";
export const GET_ADMIN_CHARTS = "GET_ADMIN_CHARTS";
export const GET_ADMIN_CHARTS_SUCCESS = "GET_ADMIN_CHARTS_SUCCESS";